import { useState } from "react";
import { Stack, Typography, Chip, Avatar } from "@mui/material";
import CommentBox from "./CommentBox"; // your full editor
import { useSelector } from "react-redux";
import { selectUserDetails } from "../../features/userSlice";
import { getInitials } from "../../utils/helpers";
import { Box } from "@mui/system";
import { useDispatch } from "react-redux";
import {
  setEditingCommentId,
  setIsExpandCommentBox,
} from "../../features/genericCommentsAndFilesSlice";

const QUICK_REPLIES = [
  { label: "Looks good!", emoji: "🎉" },
  { label: "Need help?", emoji: "🙌" },
  { label: "This is blocked...", emoji: "⛔" },
  { label: "Can you clarify...?", emoji: "🔍" },
  { label: "This is on track", emoji: "✅" },
];

const ExpandableCommentBox = ({ addComment }: { addComment: any }) => {
  const dispatch = useDispatch();

  const [initialContent, setInitialContent] = useState("");
  const activeUser = useSelector(selectUserDetails);
  const { isExpandCommentBox, editingCommentId, objectSharedUid } = useSelector(
    (state: any) => state.genericCommentsAndFiles
  );

  const handleChipClick = (text: string, event: React.MouseEvent) => {
    event.stopPropagation(); // prevent Paper's onClick from triggering when Chip is clicked
    setInitialContent(text); // set quick reply text
    dispatch(setIsExpandCommentBox(true)); // expand box
    dispatch(setEditingCommentId("")); // reset editing state
  };

  return (
    <Stack direction="column" alignItems="flex-start" spacing={2}>
      <Stack direction="row" alignItems="center" spacing={1} width="100%">
        <Avatar
          sx={{
            bgcolor: "#7B1FA2",
            width: 24,
            height: 24,
            fontSize: 12,
            mt: 1,
          }}
        >
          {getInitials(`${activeUser?.first_name} ${activeUser?.last_name}`)}
        </Avatar>
        <Typography
          variant="subtitle2"
          sx={{ color: "rgba(0, 0, 0, 0.6)" }}
        >{`${activeUser?.first_name} ${activeUser?.last_name}`}</Typography>
      </Stack>

      {isExpandCommentBox && !editingCommentId && objectSharedUid ? (
        <Box sx={{ marginLeft: "32px !important", width: "96%" }}>
          <CommentBox
            addComment={addComment}
            onCancel={() => {
              setInitialContent("");
              dispatch(setIsExpandCommentBox(false)); // reset expand state
              dispatch(setEditingCommentId("")); // reset editing state
            }}
            onAddSuccess={() => {
              dispatch(setIsExpandCommentBox(false)); // reset expand state
              dispatch(setEditingCommentId("")); // reset editing state
              setInitialContent("");
            }}
            initialContent={initialContent}
          />
        </Box>
      ) : (
        <Box
          onClick={() => {
            setInitialContent(""); // reset on manual open
            dispatch(setIsExpandCommentBox(true)); // update global state
            dispatch(setEditingCommentId("")); // reset editing state
          }}
          sx={{
            flex: 1,
            border: "1px solid rgba(0, 0, 0, 1)",
            borderRadius: 2,
            marginLeft: "32px !important",
            boxShadow: "none",
            p: 2,
            cursor: "text",
            minHeight: "104px",
            ":hover": { backgroundColor: "#f9f9f9" },
            width: "96%",
          }}
        >
          <Stack
            direction="column"
            alignItems="flex-start"
            spacing={7}
            justifyContent={"space-between"}
          >
            <Typography color="text.secondary" fontSize="14px">
              Add a comment...
            </Typography>

            <Stack
              direction="row"
              flexWrap="wrap"
              justifyContent={"flex-start"}
              alignItems={"center"}
              gap={1}
            >
              {QUICK_REPLIES.map((item) => (
                <Chip
                  key={item.label}
                  label={
                    <span>
                      {item.emoji} {item.label}
                    </span>
                  }
                  size="small"
                  variant="outlined"
                  onClick={(event) =>
                    handleChipClick(`${item.emoji} ${item.label}`, event)
                  }
                />
              ))}
            </Stack>
          </Stack>
        </Box>
      )}
    </Stack>
  );
};

export default ExpandableCommentBox;
